const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const CALLBACK_NAME = "__gitoInitGoogleMaps";

let googleMapsPromise = null;

export const hasValidCoords = (latitude, longitude) => {
    const lat = Number(latitude);
    const lng = Number(longitude);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
        return false;
    }
    if (Math.abs(lat) < 0.000001 && Math.abs(lng) < 0.000001) {
        return false;
    }
    if (lat < -90 || lat > 90 || lng < -180 || lng > 180) {
        return false;
    }
    return true;
};

export const loadGoogleMaps = () => {
    if (window.google?.maps) {
        return Promise.resolve(window.google);
    }

    if (googleMapsPromise) {
        return googleMapsPromise;
    }

    if (!GOOGLE_MAPS_API_KEY) {
        return Promise.reject(new Error("Google Maps API key is not configured."));
    }

    googleMapsPromise = new Promise((resolve, reject) => {
        window[CALLBACK_NAME] = () => {
            resolve(window.google);
        };

        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(GOOGLE_MAPS_API_KEY)}&callback=${CALLBACK_NAME}&v=weekly`;
        script.async = true;
        script.defer = true;
        script.dataset.gitoGoogleMaps = "true";
        script.onerror = () => {
            googleMapsPromise = null;
            reject(new Error("Failed to load Google Maps."));
        };
        document.head.appendChild(script);
    });

    return googleMapsPromise;
};
